import styled from 'styled-components';

import { COLORS } from 'theme';

export const FallbackContainer = styled.div`
  display: grid;
  place-items: center;
  height: 100vh;
  padding: ${({ theme }) => theme.spacing.l3};
  background-color: ${COLORS.black02};
`;

export const ContentWrapper = styled.div`
  display: grid;
  justify-items: center;
  max-width: 480px;
  text-align: center;
`;

export const Heading = styled.h2`
  margin: 0 0 ${({ theme }) => theme.spacing.s2};
  color: ${COLORS.kinetikBlack};
  font-size: ${({ theme }) => theme.fontSize.h4};
`;

export const SubText = styled.p`
  margin: 0 0 ${({ theme }) => theme.spacing.m2};
  color: ${({ theme }) => theme.text.secondary};
  font-size: ${({ theme }) => theme.fontSize.body2};
`;

export const Actions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s3};
`;

export const ErrorDetails = styled.details`
  margin-top: ${({ theme }) => theme.spacing.m2};
  text-align: left;
`;

export const ErrorPre = styled.pre`
  font-size: ${({ theme }) => theme.fontSize.body3};
  overflow: auto;
`;
